
  export const style={
    inpuStyle:{
      colorInput:"#80297D"
    },
    url:{
      urlClient:"https://solidianos.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_solides.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Sólides Coin/Sólides Coins"
    },
    teamName:{
      name:"Solidianos"
    },
    hasToken: true,
    hostHeader: "solides"
  }
